/** Full display name for a user object from the API. */
export function userDisplayName(user) {
  if (!user) return "Unknown";
  const first = user.first_name?.trim();
  const last = user.last_name?.trim();
  if (first && last) return `${first} ${last}`;
  if (first) return first;
  if (last) return last;
  if (user.name?.trim()) return user.name.trim();
  return user.email || "Unknown";
}

export function userInitial(user) {
  const name = userDisplayName(user);
  return (name[0] || "?").toUpperCase();
}
